module.exports = __webpack_public_path__ + "static/media/line2.e56d55c9.jpg";